import { useState, useEffect, useCallback } from 'react'

import { fetchOrders } from '@/core/api/ordersService'
import { fetchInvoices } from '@/core/api/invoicesService'
import { fetchPayments } from '@/core/api/paymentsService'
import { fetchCompanies } from '@/core/api/companiesService'
import type { Order, Payment, Invoice, Company } from '@/features/classes/stores/types'

export interface SalesData {
  orders: Order[]
  payments: Payment[]
  invoices: Invoice[]
  companies: Company[]
}

export function useSalesData() {
  const [data, setData] = useState<SalesData>({
    orders: [],
    payments: [],
    invoices: [],
    companies: [],
  })
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    const [orders, payments, invoices, companies] = await Promise.all([
      fetchOrders(),
      fetchPayments(),
      fetchInvoices(),
      fetchCompanies(),
    ])
    setData({ orders, payments, invoices, companies })
    setLoading(false)
  }, [])

  const refresh = useCallback(async () => {
    setLoading(true)
    await load()
  }, [load])

  useEffect(() => {
    let cancelled = false

    load()
      .catch(() => {
        if (!cancelled) {
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [load])

  return { ...data, loading, refresh }
}
